// extracted by mini-css-extract-plugin
export default {"container":"MiddlePanel_container__bm2rB"};